export var ENTER_ANNOTATION_MODE = 'ENTER_ANNOTATION_MODE';
export var LEAVE_ANNOTATION_MODE = 'LEAVE_ANNOTATION_MODE';
export var ADD_NEW_ANNOTATION = 'ADD_NEW_ANNOTATION';
export var ADD_ANNOTATION = 'ADD_ANNOTATION';
export var REMOVE_ANNOTATION = 'REMOVE_ANNOTATION';
export var POSITION_ANNOTATION = 'POSITION_ANNOTATION';
export var SCROLL_TO_ANNOTATION = 'SCROLL_TO_ANNOTATION';
export var HIGHLIGHT_ANNOTATION = 'HIGHLIGHT_ANNOTATION';
export var UNHIGHLIGHT_ANNOTATION = 'UNHIGHLIGHT_ANNOTATION';
export var PULSE_ANNOTATION = 'PULSE_ANNOTATION';
export var CLEAR_ANNOTATIONS = 'CLEAR_ANNOTATIONS';
export var MAKE_ANNOTATION_MOVEABLE = 'MAKE_ANNOTATION_MOVEABLE';
export var CANCEL_ANNOTATION = 'CANCEL_ANNOTATION';
export var MARK_ANNOTATION_SAVED = 'MARK_ANNOTATION_SAVED';
export var ANNOTATION_COMMENT_UPDATED = 'ANNOTATION_COMMENT_UPDATED';
export var UPDATE_ANNOTATION = 'UPDATE_ANNOTATION';
